function rejectDesign(item_id) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/design-rejection`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      item_id: `${item_id}`,
    },
  })
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default rejectDesign;
